import RcmpHeader from "../../../../atoms/Header"
import intl from "react-intl-universal"
import ContentBlank from "../../../../molecules/ContentBlank"
import IconCiq from "../../../../../assets/icons/CIQIcon"
import styles from "./index.module.scss"
import PageTabs from "../../../CQIPage/components/PageTabs"

export default function SigmaDefault({ children, setCSearch, ...rest }) {
  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      bActive: true,
      name: intl.get("ciq.title"),
    },
  ]

  return (
    <div>
      <RcmpHeader
        elIcon={<IconCiq />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={aBreadCrumbs}
        className={styles.header}
      >
        <PageTabs currentTab={2} />
      </RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bSwitchable={false}
        bVisibleIconSearch={true}
        className={styles.contentBlankCustom}
        cText={intl.get("sigma.title")}
        setSearchTerm={(e) => {
          setCSearch(!e ? "" : `&search_text=${e.toLowerCase()}`)
        }}
        bHasVideoTutorial={true}
        {...rest}
      >
        {children}
      </ContentBlank>
    </div>
  )
}
